import { useUTLSettingsContext } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { useMemo } from "react";
import type { AreaIds } from "../config/assetFieldConfig";

export const useAreaIds = () => {
	const { state } = useUTLSettingsContext();

	const defaultAssetId = Number(get(state, "settings.DefaultAssetId", 0));

	const areaIds: AreaIds = useMemo(
		() => ({
			welds: Number(get(state, "settings.DefaultAreaId", 0)),
			saws: Number(get(state, "settings.SawsAreaId", 0)),
			wax: Number(get(state, "settings.WaxAreaId", 0)),
			paint: Number(get(state, "settings.PaintAreaId", 0)),
			punch: Number(get(state, "settings.PunchAreaId", 0)),
			clips: Number(get(state, "settings.ClipsAreaId", 0)),
		}),
		[state],
	);

	return { areaIds, defaultAssetId };
};
